export const primaryButtonColor = '#4786FF';
export const titleTextColor = '#102142';
export const regularTextColor = '#404D68';
